var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RegulatedProductStatementDeclaration',{attrs:{"border-variant":"light","selection-mode":"radio","show-comment":"","properties":_vm.rows},on:{"change":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }